import React from "react";
import "./About.css";
import { Container, Row, Col } from "react-bootstrap";
import profile from "../images/rsz__mg_5266.jpg";

const About = () => {
  const calculate_age = (dob) => {
    const diff_ms = Date.now() - dob.getTime();
    const age_dt = new Date(diff_ms);

    return Math.abs(age_dt.getUTCFullYear() - 1970);
  };
  return (
    <div className="BG" id="about">
      <div className="container">
        <Container className="jutify">
          <Row>
            <Col lg={6} md={12} xs={12}>
              <img
                className="display img-fluid"
                style={{ width: "400px" }}
                src={profile}
                alt="pro"
              />
            </Col>
            <Col lg={6} md={12} xs={12}>
              <div className="writing">
                <h1>Al Shadab Arnab</h1>
                <h5>
                  A{" "}
                  <span style={{ color: "#dc965a" }}>
                    MERN Stack Website Developer
                  </span>{" "}
                  based in <span style={{ color: "#dc965a" }}>Bangladesh</span>
                </h5>
                <p>
                  I design and develop services for customers of all sizes,
                  specializing in creating stylish, modern websites, web
                  services and online stores. My passion is to design digital
                  user experiences through the bold interface and meaningful
                  interactions. Check out my Portfolio
                </p>

                <div className="info">
                  <Row>
                    <Col md={6} lg={6}>
                      <div>
                        <h6>
                          <span className="style-info">
                            Birthday &nbsp;&nbsp;&nbsp;&nbsp;|
                          </span>{" "}
                          1st December 1999
                        </h6>
                        <br />
                        <h6>
                          <span className="style-info">
                            Age
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
                          </span>{" "}
                          {calculate_age(new Date(1999, 12, 1))} years
                        </h6>
                        <br />
                        <h6>
                          <span className="style-info">
                            Residence &nbsp;&nbsp;|
                          </span>{" "}
                          Bangladesh
                        </h6>
                        <br />

                        <h6>
                          <span className="style-info">
                            Address &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
                          </span>{" "}
                          Narayanganj, Dhaka
                        </h6>
                      </div>
                    </Col>
                    <Col md={6} lg={6}>
                      <div>
                        <h6>
                          <sapn className="style-info">
                            E-mail
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
                          </sapn>{" "}
                          alshadabarnab@gmail.com
                        </h6>
                        <br />
                        <h6>
                          <span className="style-info">
                            Contact &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
                          </span>{" "}
                          +8801832296784
                        </h6>
                        <br />
                        <h6>
                          <span className="style-info">
                            Whatsapp &nbsp;&nbsp;|
                          </span>{" "}
                          +8801832296784
                        </h6>
                        <br />
                        <h6>
                          <span className="style-info">
                            Freelance &nbsp;&nbsp;&nbsp;&nbsp;|
                          </span>{" "}
                          Available
                        </h6>
                        <button>
                          <a
                            href="https://drive.google.com/drive/folders/1wRrJs97IUeSuWMxaqxwjnqRuCvUZC4ay?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download CV
                          </a>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
